export default {
  title: 'Словари',

  states: {
    loading: 'Загружено {count}.',
    processing: 'Обработка...',
    import: 'Импортировано {count} строк.',
    done: 'Импортировано {count} строк.'
  },

  dialogs: {
    create: 'Создать новый ключ',

    titles: {
      remove: 'Подтверждение удаления словаря'
    }
  },

  new: {
    key: 'Новый ключ'
  },

  titles: {
    'phone:mnp': 'MNP',
    'phone:ranges': 'Префиксы',
    'phone:opgroups': 'Группы операторов',
    upload: 'Загрузка',
    import: 'Импорт',
    mix: 'Подмешать префиксы с сервера партнёра?',
    createGroup: 'Создать группу оператора',
    group: 'Группа',
    operator: 'Оператор',
    number: 'Номер',
    mcc: 'MCC',
    mnc: 'MNC',

    service: {
      mnp: 'MNP',
      ranges: 'Диапазоны',
      operatorGroups: 'Группы операторов'
    }
  },

  labels: {
    key: 'Ключ',
    opcode: 'Код оператора',
    group: 'Группа',
    groupName: 'Имя группы',
    operatorName: 'Имя оператора',
    operator: 'Оператор',
    number: 'Номер',
    region: 'Регион',
    prefix: 'Префикс',
    mcc: 'MCC',
    mnc: 'MNC',
    type: 'Тип словаря',
    regionCode: 'Код региона',
    regionName: 'Название региона',
    countryCode: 'Код страны',
    countryName: 'Название страны',
    timeZone: 'Часовой пояс',
    status: 'Статус',
    OwnerId: 'Владелец',
    total: 'Всего: {total}',

    ranges: {
      start: 'Начало диапазона',
      end: 'Конец диапазона'
    },

    choose: {
      dictionary: 'Выбрать словарь',
      key: 'Ввести ключ'
    },

    search: {
      keys: 'Поиск по ключам'
    }
  },

  hints: {
    noItems: 'Нет словарей для отображения',
    loading: 'Не закрывайте или не перезагружайте окно во время процесса импорта.',
    importOr: 'Или выберите файл через файловый менеджер',

    empty: {
      default: 'Здесь появятся результаты поиска',
      search: 'Для данного номера данные не найдены'
    }
  },

  buttons: {
    compile: 'Скомпилировать',
    set: 'Активировать',
    unset: 'Деактивировать',

    add: {
      range: 'Добавить диапазон'
    }
  },

  contents: {
    confirm: {
      remove: {
        dictionary: 'Вы уверены что хотите удалить словарь {title}?',
        key: 'Вы уверены что хотите удалить ключ {title}?'
      }
    }
  },

  snackbars: {
    updated: 'Словарь успешно обновлён.',

    dictionary: {
      created: 'Словарь успешно создан.',
      compile: 'Словарь успешно скомпилирован',
      updated: 'Словарь успешно обновлён.',
      removed: 'Словарь успешно удалён.'
    },

    key: {
      created: 'Ключ в словаре успешно создан.',
      updated: 'Ключ в словаре успешно обновлён.',
      removed: 'Ключ в словаре успешно удалён.'
    }
  },

  statuses: {
    created: 'Создан',
    ready: 'Готов',
    downloading: 'Скачивается',
    importing: 'Импортируется',
    importError: 'Ошибка в процессе импорта',
    compiling: 'Компилируется',
    compiled: 'Скомпилирован',
    compileError: 'Ошибка в процессе компиляции',
    activated: 'Активирован'
  },

  tooltips: {
    info: 'Подробности о формате CSV файла',

    upload: {
      file: 'Импортировать из файла',
      partner: 'Импортировать с сервера партнёра'
    }
  },

  filters: {
    items: {
      default: 'Системные словари'
    }
  },

  info: {
    hint: 'Названия столбцов чувствительны к регистру',

    rows: {
      Number: 'номер телефона',
      OwnerId: 'название оператора',
      MCC: 'MCC',
      MNC: 'MNC',
      NumberFrom: 'номер телефона, с которого начинается диапазон',
      NumberTo: 'номер телефона, которым заканчивается диапазон',
      RegionCode: 'код региона',
      GROUP: 'название группы',
      OrgCode: 'название оператора',
      TYPE: 'тип номера телефона (городской ABC, мобильный DEF)'
    }
  }
}
